// Real Time Table suggestive word/key
export const dynamicRows = [ 'status' ]
export const realTimeTableKey = 'GetDataByUser'

import i18n from '@/i18n'

// Base config without labels - labels are added dynamically via getDynamicColumns()
const dynamicColumnsBase = [
    {
        prop: 'online_user_id',
        fixed: false,
        align: 'center',
    },
    {
        prop: 'representant',
        fixed: false,
        align: 'center',
    },
    {
        prop: 'user_name',
        fixed: false,
        align: 'center',
    },
    {
        prop: 'extension_name',
        fixed: false,
        align: 'center',
    },
    {
        prop: 'extension_id',
        fixed: false,
        align: 'center',
    },
    {
        prop: 'status',
        fixed: false,
        align: 'center',
    },
    {
        prop: 'status_duration',
        fixed: false,
        align: 'center',
        width: '250px',
    },
    {
        prop: 'caller_info',
        fixed: false,
        align: 'center',
        sortable: false,
    },
    {
        prop: 'call_info',
        fixed: false,
        align: 'center',
        sortable: false,
    }
]

// Helper function to generate column with translated label at runtime
function generateColumnWithLabel (column) {
    return {
        ...column,
        label: i18n.t(`widget.realtimeTable.column.${column.prop}`),
    }
}

// Returns columns with translated labels - call at runtime when translations are available
export function getDynamicColumns () {
    return dynamicColumnsBase.map(generateColumnWithLabel)
}
